import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { EverythingWrapperProps } from '@widgets/Teaser/standard/types'
import {
  desktopCSS,
  tabletCSS,
  smallMobileCSS,
  regularMobileCSS,
} from '@measures/responsive'
import Blink from '@components/Blink'

type StyledEverythingWrapperProps = Pick<
  StandardTeaserLayoutContextType,
  'teaserFlex' | 'isInMegaModule'
>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledEverythingWrapper = styled(Blink)<StyledEverythingWrapperProps>`
  display: block;
  position: relative;
  width: 100%;
  height: 0;
  text-decoration: none;

  ${({ teaserFlex, isInMegaModule }) => {
    let desktopStyles
    if (isInMegaModule) {
      desktopStyles = css`
        padding-bottom: 150px;
      `
    } else if (teaserFlex === '3') {
      desktopStyles = css`
        padding-bottom: 77%;
      `
    } else {
      desktopStyles = css`
        padding-bottom: 100%;
      `
    }

    return css`
      ${desktopCSS(css`
        ${desktopStyles}
      `)}

      ${tabletCSS(css`
        padding-bottom: ${isInMegaModule ? '150px' : '100%'};
      `)}

      ${smallMobileCSS(css`
        padding-bottom: 150px;
      `)}

      ${regularMobileCSS(css`
        padding-bottom: 160px;
      `)}
    `
  }}
`

const EverythingWrapper: FunctionComponent<EverythingWrapperProps> = ({
  children,
  clickableProps,
  viewportRef,
}) => {
  const { teaserFlex, isInMegaModule } = useContext(StandardTeaserLayoutContext)

  return (
    <StyledEverythingWrapper
      ref={viewportRef}
      {...clickableProps}
      teaserFlex={teaserFlex}
      isInMegaModule={isInMegaModule}>
      {children}
    </StyledEverythingWrapper>
  )
}

export default EverythingWrapper
